import React from 'react';
import { Typography, Stack, Box } from '@mui/material';
import SEOHead from './SEO/SEOHead';
import { styled } from '@mui/material/styles';
import ResponsiveContainer from '../components/layout/ResponsiveContainer';
import SectionTitle from './shared/SectionTitle';

const PageWrapper = styled('div')(({ theme }) => ({
    width: '100%',
    paddingBottom: theme.spacing(6)
}));

const HeroSection = styled(Box)(({ theme }) => ({
    background: 'linear-gradient(135deg, #1a2e4a 0%, #2a4a6e 100%)',
    color: '#ffffff',
    padding: theme.spacing(8, 2),
    textAlign: 'center',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M30 0L60 30L30 60L0 30z' fill='%23ffffff' fill-opacity='0.02'/%3E%3C/svg%3E")`,
        backgroundSize: '60px 60px',
    },
}));

const SailImage = styled('img')(({ theme }) => ({
    width: '300px',
    maxWidth: '100%',
    height: 'auto',
    objectFit: 'contain',
    [theme.breakpoints.down('sm')]: {
        width: '100%'
    }
}));

const FeatureList = styled('ul')(({ theme }) => ({
    listStyle: 'none',
    padding: 0,
    margin: 0,
    '& li': {
        padding: '4px 0',
        position: 'relative',
        paddingLeft: '20px',
        '&:before': {
            content: '""',
            position: 'absolute',
            left: 0,
            top: '50%',
            transform: 'translateY(-50%)',
            width: '6px',
            height: '6px',
            borderRadius: '50%',
            backgroundColor: theme.palette.orange.main
        }
    }
}));

const CodeZeroSailsPage = () => {
    return (
        <PageWrapper>
            <SEOHead page="codeZeroSails" />
            
            {/* Navy Hero Section */}
            <HeroSection>
                <Box sx={{ position: 'relative', maxWidth: '800px', margin: '0 auto' }}>
                    <Typography 
                        variant="h2" 
                        sx={{ 
                            fontWeight: 500,
                            mb: 2,
                            fontSize: { xs: '2rem', md: '2.75rem' },
                            color: '#ffffff',
                        }}
                    >
                        Code Zero Sails
                    </Typography>
                    <Typography 
                        sx={{ 
                            fontSize: '1.15rem',
                            fontWeight: 300,
                            opacity: 0.9,
                            maxWidth: '600px',
                            margin: '0 auto',
                            color: '#ffffff',
                        }}
                    >
                        High Performance Tight Reaching Sails
                    </Typography>
                </Box>
            </HeroSection>

            <ResponsiveContainer maxWidth="lg" sx={{ mt: 4 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 3, md: 4 } }}>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        gap: { xs: 2, sm: 3 },
                        alignItems: 'flex-start'
                    }}>
                        <Box sx={{ flexShrink: 0 }}>
                            <SailImage
                                src="/images/CodeZeroSails_1.jpg"
                                alt="Code Zero Sail"
                            />
                        </Box>
                        <Box sx={{ flex: 1 }}>
                            <Typography variant="h5" sx={{ mb: 1 }}>
                                Code Zero (A0)
                            </Typography>
                            <Typography variant="body1">
                                The Code 0 is a tight reaching sail, designed to be the most upwind capable
                                of the asymmetric sails. Perfect for light air conditions when you need
                                maximum performance and sail area.
                            </Typography>
                        </Box>
                    </Box>

                    <Box>
                        <SectionTitle sx={{ mb: 1 }}>
                            Available in:
                        </SectionTitle>
                        <FeatureList>
                            <li>Dimension Polyant CZ (code zero)</li>
                        </FeatureList>
                    </Box>
                </Box>
            </ResponsiveContainer>
        </PageWrapper>
    );
};

export default CodeZeroSailsPage;
